import {
  LuHouse, LuZap, LuHistory, LuUserRound,
  LuCar, LuSettings, LuLifeBuoy, LuLogOut, LuTicket,
} from 'react-icons/lu';

// Primary destinations — surfaced in both mobile bottom nav and
// desktop sidebar. Order matters (visual left→right on mobile).
//
// `Redeem Codes` is inserted between `Activity` and `Account` per the
// product's authenticated-nav spec. `match` intentionally uses
// `startsWith` so a future `/redeem-codes/:id` detail route also
// keeps this item selected. `mobileLabel` overrides `label` in the
// bottom-nav only so the tighter phone layout can say "Redeem" while
// the desktop sidebar keeps the fuller "Redeem Codes".
export const PRIMARY_NAV = [
  { key: 'home',     label: 'Home',         to: '/',              icon: LuHouse,      match: (path) => path === '/' },
  { key: 'charge',   label: 'Find Charger', to: '/charge',        icon: LuZap,        match: (path) => path.startsWith('/charge') },
  { key: 'history',  label: 'Activity',     to: '/history',       icon: LuHistory,    match: (path) => path.startsWith('/history') },
  { key: 'redeem',   label: 'Redeem Codes', mobileLabel: 'Redeem', to: '/redeem-codes', icon: LuTicket, match: (path) => path.startsWith('/redeem-codes') },
  { key: 'account',  label: 'Account',      to: '/profile',       icon: LuUserRound,  match: (path) => path.startsWith('/profile') || path.startsWith('/settings') || path.startsWith('/support') || path.startsWith('/vehicles') },
];

// Secondary sidebar items — desktop only.
export const SECONDARY_NAV = [
  { key: 'vehicles', label: 'My Vehicles',  to: '/vehicles', icon: LuCar },
  { key: 'settings', label: 'Settings',     to: '/settings', icon: LuSettings },
  { key: 'support',  label: 'Support',      to: '/support',  icon: LuLifeBuoy },
];

export const SIGN_OUT_ITEM = { key: 'logout', label: 'Sign out', icon: LuLogOut };
